/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as FieldsetDefault } from './fieldset-default.story';
export { default as FieldsetDisabled } from './fieldset-disabled.story';
export { default as FieldsetError } from './fieldset-error.story';
export { default as FieldsetOptional } from './fieldset-optional.story';
export { default as FieldsetRequired } from './fieldset-required.story';
export { default as FieldsetVisuallyHiddenLabel } from './fieldset-visually-hidden-label.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import FieldsetDefaultSrcRaw from './fieldset-default.story?raw';
import FieldsetDisabledSrcRaw from './fieldset-disabled.story?raw';
import FieldsetErrorSrcRaw from './fieldset-error.story?raw';
import FieldsetOptionalSrcRaw from './fieldset-optional.story?raw';
import FieldsetRequiredSrcRaw from './fieldset-required.story?raw';
import FieldsetVisuallyHiddenLabelSrcRaw from './fieldset-visually-hidden-label.story?raw';

export const FieldsetDefaultSrc = removeLicenseHeader(FieldsetDefaultSrcRaw);
export const FieldsetDisabledSrc = removeLicenseHeader(FieldsetDisabledSrcRaw);
export const FieldsetErrorSrc = removeLicenseHeader(FieldsetErrorSrcRaw);
export const FieldsetOptionalSrc = removeLicenseHeader(FieldsetOptionalSrcRaw);
export const FieldsetRequiredSrc = removeLicenseHeader(FieldsetRequiredSrcRaw);
export const FieldsetVisuallyHiddenLabelSrc = removeLicenseHeader(
  FieldsetVisuallyHiddenLabelSrcRaw,
);
